<template>
  <div class="vue-tempalte">
    <!-- Navigation -->
    <div class="d-flex mb-4">
      <nav
        class="navbar shadow bg-white rounded justify-content-between d-flex flex-row fixed-top"
      >
        <a
          class="navbar-brand float-left"
          href="http://admin.tsiklauri.ge"
          target="_blank"
        >
          ადმინისტრაცია
        </a>
        <ul class="nav navbar-nav flex-row float-right">
          <li class="nav-item">
            <router-link class="nav-link pr-3" to="/login">შესვლა</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link pr-3" to="/">გამოსვლა</router-link>
          </li> -->
          <li class="nav-item">
            <router-link class="btn btn-outline-primary" to="/signup"
              >რეგისტრაცია</router-link
            >
          </li>
        </ul>
      </nav>
    </div>
    <!-- Main -->
    <div
      class="App container-fluid d-flex justify-content-center"
      style="margin-top: 8em"
    >
      <div class="col-md-6 col-lg-8">
        <div class="flex-column">
          <router-view />
        </div>
      </div>
    </div>

    <!-- Footer -->
    <nav class="navbar navbar-expand-sm bg-dark navbar-dark fixed-bottom">
      <div class="col-md-12 text-center">
        <a class="nav-link" href="https://tsiklauri.ge"
          >ვებ გვერდი დამზადებული წიკლაურთა საგვარეულო ერთობის მიერ</a
        >
      </div>
      <!-- <div class="col-md-12">
          <span class="nav-item"> ავტორი:</span>
          <a class="nav-link" href="mailto:shtscompany@gmail.com"> შოთა წიკლაურის</a>
          <span class="nav-item">მიერ</span>
      </div> -->
    </nav>
  </div>
</template>

<script>
/* eslint-disable */
import firebase from "firebase";

export default {
  data() {
    return {
      user: null,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  },
  methods: {
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          firebase.auth().onAuthStateChanged(() => {
            this.$router.push("/login");
          });
        });
    },
  },
};
</script>
